(function (global) {
  'use strict';

  var VERSION = 'p0_v1';
  var ENTRY_KEY = 'qy_lamp_entry_p0_v1';
  var CHECKOUT_KEY = 'qy_lamp_checkout_p0_v1';
  var MARKER_TTL_MS = 30 * 60 * 1000;
  var pageEvents = {};
  var clickEvents = typeof WeakSet === 'function' ? new WeakSet() : null;
  var lampFormState = { started: false, completed: false, checkout: false };

  if (global.QiyuanLampAnalytics && global.QiyuanLampAnalytics.version === VERSION) return;

  function now() {
    return Date.now();
  }

  function storageRead(key) {
    try {
      var raw = global.sessionStorage && global.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function storageWrite(key, value) {
    try {
      if (global.sessionStorage) global.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Analytics must never interrupt the memorial journey when storage is unavailable.
    }
  }

  function storageRemove(key) {
    try {
      if (global.sessionStorage) global.sessionStorage.removeItem(key);
    } catch (error) {
      // Analytics must never interrupt the memorial journey when storage is unavailable.
    }
  }

  function markerIsFresh(marker) {
    return Boolean(marker && Number.isFinite(marker.at) && now() - marker.at <= MARKER_TTL_MS);
  }

  function canonicalSend(name, parameters) {
    if (typeof global.qySend !== 'function') return false;
    global.qySend(name, parameters);
    return true;
  }

  function isZhongyuanLanding() {
    return Boolean(
      global.location &&
        String(global.location.pathname || '').replace(/\/+$/, '') ===
          '/pages/zhongyuan-remembrance-2026'
    );
  }

  function isDizangQuery() {
    if (!global.location || typeof global.URLSearchParams !== 'function') return false;
    return new global.URLSearchParams(global.location.search || '').get('qy_garden') === 'dizang';
  }

  function entrySource() {
    var marker = storageRead(ENTRY_KEY);
    if (markerIsFresh(marker) && marker.source === 'zhongyuan_ads') {
      return 'zhongyuan_ads';
    }

    try {
      var referrer = global.document && global.document.referrer;
      var referrerUrl = referrer ? new global.URL(referrer, global.location.origin) : null;
      if (
        referrerUrl &&
        referrerUrl.origin === global.location.origin &&
        referrerUrl.pathname.replace(/\/+$/, '') === '/pages/zhongyuan-remembrance-2026'
      ) {
        return 'zhongyuan_ads';
      }
    } catch (error) {
      // A malformed or unavailable referrer is categorized without emitting its value.
    }

    return 'direct_or_other';
  }

  function rememberEntry() {
    storageWrite(ENTRY_KEY, { source: 'zhongyuan_ads', at: now() });
  }

  function rememberClickEvent(event) {
    if (!event || event.type !== 'click' || event.isTrusted !== true) return false;
    if (clickEvents) {
      if (clickEvents.has(event)) return false;
      clickEvents.add(event);
      return true;
    }
    if (event.__qyLampAnalyticsHandled) return false;
    try {
      event.__qyLampAnalyticsHandled = true;
    } catch (error) {
      return false;
    }
    return true;
  }

  function formState(form) {
    if (!form) return null;
    return lampFormState;
  }

  function resetFormLifecycle(form) {
    if (!form) return;
    lampFormState = { started: false, completed: false, checkout: false };
  }

  function durationCode(value) {
    return ['1d', '7d', '49d', '100d', '1y'].indexOf(value) !== -1 ? value : 'unknown';
  }

  function currencyCode(value) {
    var normalized = String(value || '').toUpperCase();
    return /^[A-Z]{3}$/.test(normalized) ? normalized : '';
  }

  function itemId(value) {
    var normalized = String(value || '');
    return /^\d+$/.test(normalized) ? normalized : '';
  }

  function moneyValue(value) {
    var number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
  }

  function safeCtaLocation(value) {
    return ['hero', 'steps', 'final'].indexOf(value) !== -1 ? value : 'unknown';
  }

  function lampParameters(extra) {
    var values = extra || {};
    return {
      page_path: values.page_path,
      page_type: values.page_type,
      destination: values.destination,
      cta_location: values.cta_location,
      garden: 'dizang',
      entry_source: values.entry_source,
      product_type: 'remembrance_lamp',
      duration_code: values.duration_code,
      event_version: VERSION,
    };
  }

  function compact(parameters) {
    var output = {};
    Object.keys(parameters).forEach(function (key) {
      if (parameters[key] !== undefined && parameters[key] !== null && parameters[key] !== '') {
        output[key] = parameters[key];
      }
    });
    return output;
  }

  function trackCtaClick(event, metadata) {
    if (!isZhongyuanLanding() || !rememberClickEvent(event)) return false;
    rememberEntry();
    return canonicalSend(
      'lamp_cta_click',
      compact(
        lampParameters({
          page_path: '/pages/zhongyuan-remembrance-2026',
          page_type: 'zhongyuan_ads_landing',
          destination: 'dizang',
          cta_location: safeCtaLocation(metadata && metadata.cta_location),
          entry_source: 'zhongyuan_ads',
        })
      )
    );
  }

  function trackGardenView() {
    var key = 'memorial_garden_view:dizang';
    if (!isDizangQuery() || pageEvents[key]) return false;
    if (
      canonicalSend(
        'memorial_garden_view',
        compact(
          lampParameters({
            page_path: '/',
            page_type: 'memorial_garden',
            destination: 'dizang',
            entry_source: entrySource(),
          })
        )
      )
    ) {
      pageEvents[key] = true;
      return true;
    }
    return false;
  }

  function trackFormStart(form, metadata) {
    var state = formState(form);
    if (!state || state.started || !isDizangQuery()) return false;
    if (
      canonicalSend(
        'lamp_form_start',
        compact(
          lampParameters({
            page_path: '/',
            page_type: 'memorial_garden',
            entry_source: entrySource(),
            duration_code: durationCode(metadata && metadata.duration_code),
          })
        )
      )
    ) {
      state.started = true;
      return true;
    }
    return false;
  }

  function trackFormComplete(form, metadata) {
    var state = formState(form);
    if (!state || state.completed || !isDizangQuery() || !metadata || metadata.preview_ready !== true) {
      return false;
    }
    if (
      canonicalSend(
        'lamp_form_complete',
        compact(
          lampParameters({
            page_path: '/',
            page_type: 'memorial_garden',
            entry_source: entrySource(),
            duration_code: durationCode(metadata.duration_code),
          })
        )
      )
    ) {
      state.completed = true;
      return true;
    }
    return false;
  }

  function trackBeginCheckout(form, metadata) {
    var state = formState(form);
    var id = itemId(metadata && metadata.item_id);
    var currency = currencyCode(metadata && metadata.currency);
    var value = moneyValue(metadata && metadata.value);
    var duration = durationCode(metadata && metadata.duration_code);
    var parameters;

    if (
      !state ||
      state.checkout ||
      !isDizangQuery() ||
      !metadata ||
      metadata.checkout_ready !== true ||
      !id ||
      !currency ||
      value === null ||
      duration === 'unknown'
    ) {
      return false;
    }

    parameters = compact(
      lampParameters({
        page_path: '/',
        page_type: 'memorial_garden',
        entry_source: entrySource(),
        duration_code: duration,
      })
    );
    parameters.currency = currency;
    parameters.value = value;
    parameters.items = [
      {
        item_id: id,
        item_name: 'Remembrance Lamp',
        item_variant: duration,
        price: value,
        quantity: 1,
      },
    ];

    if (!canonicalSend('begin_checkout', parameters)) return false;
    state.checkout = true;
    storageWrite(CHECKOUT_KEY, { item_id: id, duration_code: duration, at: now() });
    return true;
  }

  function consumeRecentLampCheckout(itemIds) {
    var marker = storageRead(CHECKOUT_KEY);
    var normalizedIds = (Array.isArray(itemIds) ? itemIds : []).map(itemId).filter(Boolean);
    if (!markerIsFresh(marker) || !itemId(marker && marker.item_id)) {
      storageRemove(CHECKOUT_KEY);
      return false;
    }
    if (normalizedIds.indexOf(String(marker.item_id)) === -1) return false;
    storageRemove(CHECKOUT_KEY);
    return true;
  }

  global.QiyuanLampAnalytics = {
    version: VERSION,
    trackCtaClick: trackCtaClick,
    trackGardenView: trackGardenView,
    trackFormStart: trackFormStart,
    trackFormComplete: trackFormComplete,
    trackBeginCheckout: trackBeginCheckout,
    consumeRecentLampCheckout: consumeRecentLampCheckout,
    resetFormLifecycle: resetFormLifecycle,
  };
})(typeof window !== 'undefined' ? window : globalThis);
